import { ThirdPartyAccount } from '@app/client/settings/shared/modules/integrations/integrations.model';
import { StateToken } from '@ngxs/store';
import { CustomerSummary } from '../../../models/common.models';
import { Currency, Customer } from '../../../models/customer.models';

export interface CustomerStateModel {
  details?: Customer;
  summary?: CustomerSummary;
  thirdPartyAccounts?: ThirdPartyAccount[];
  customersCount?: number;
  userCurrency?: Currency;
  currencyRates?: Record<Currency, number>;
}

export const CUSTOMER_STATE_TOKEN = new StateToken<CustomerStateModel>('customer');
